import { ArtImage } from '../art-image'
import {
  EndContent,
  CircleImage,
  OrderMobileContent,
  SummaryContent,
  Text,
  ArtImageContent,
} from './order-mobile.styled'
import { OrderDetails } from './order-details'
import { useOrderMobile } from './use-order-mobile'
import { useTranslation } from 'react-i18next'

export const OrderMobile: React.FC = () => {
  const {
    order,
    isOrderDetailsMobileShow,
  } = useOrderMobile()
  const { t } = useTranslation()

  return (
    <OrderMobileContent>
      <SummaryContent>
        {order?.items && (
          <EndContent>
            <ArtImageContent>
              {order.items.map((item, index) => (
                <CircleImage key={index}>
                  <ArtImage src="adfasdasd" alt="art image" />
                </CircleImage>
              ))}
            </ArtImageContent>
            <Text>{order.items.length} {t('items')}</Text>
          </EndContent>
        )}
      </SummaryContent>
      {isOrderDetailsMobileShow && <OrderDetails />}
    </OrderMobileContent>
  )
}
